import {ArrowUpRightIcon} from '@primer/octicons-react'
import {useAllThreads} from '../../../../../stores/layout-selectors'
import {MiniMergeStatusItem} from './MiniMergeStatusItem'
import {MiniMergeStatusBoundary} from './MiniMergeStatusBoundary'
import {ViewMode} from '../../../../comments/utils/view-mode'
import {routeToCommentsSection, useCurrentPathParams} from '../../../data/use-comments-routing'

export function CommentsMiniStatus() {
  const pathParams = useCurrentPathParams()
  const threads = useAllThreads()
  const totalThreads = threads.length
  const resolvedThreads = threads.filter(thread => thread.isResolved).length
  const isUnavailable = totalThreads === 0
  const iconType = totalThreads === 0 ? 'empty' : resolvedThreads === totalThreads ? 'success' : 'warning'
  return (
    <MiniMergeStatusItem
      aria-label={isUnavailable ? 'Resolved comments' : 'View unresolved comments'}
      to={isUnavailable ? undefined : routeToCommentsSection(pathParams, ViewMode.ThreadPreviews)}
    >
      <MiniMergeStatusItem.LabelRow icon={isUnavailable ? undefined : ArrowUpRightIcon}>
        <MiniMergeStatusItem.Label
          icon={iconType}
          isUnavailable={isUnavailable}
          successful={resolvedThreads}
          total={totalThreads}
        >
          Resolved comments
        </MiniMergeStatusItem.Label>
      </MiniMergeStatusItem.LabelRow>
      <MiniMergeStatusItem.Progress
        aria-label={`${resolvedThreads} of ${totalThreads} resolved comments`}
        isUnavailable={isUnavailable}
        successful={resolvedThreads}
        total={totalThreads}
        unavailableLabel="No comments available"
      />
    </MiniMergeStatusItem>
  )
}

export function CommentsMiniStatusBoundary({children}: {children: React.ReactNode}) {
  const pathParams = useCurrentPathParams()
  return (
    <MiniMergeStatusBoundary
      actionLabel="View unresolved comments"
      boundaryName="CommentsMiniStatusBoundary"
      text="Resolved comments"
      to={routeToCommentsSection(pathParams, ViewMode.ThreadPreviews)}
    >
      {children}
    </MiniMergeStatusBoundary>
  )
}
